import { SubscriptionIntegrationSchema } from "@redotech/redo-subscriptions-common/subscription-integration";
import * as z from "zod";

export const getCustomerSubscriptions = {
  name: "getCustomerSubscriptions" as const,
  input: z.object({ customerEmail: z.string().email() }),
  output: z.object({
    subscriptions: z.array(SubscriptionIntegrationSchema),
    totalCount: z.number(),
    hasSubscriptionIntegration: z.boolean(),
  }),
};
